module.exports = "<span *ngIf=\"(isConnected | async)?.$value\" class=\"bg-danger\"></span>"